// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__2grJ2"};